import { getString } from "../../common/common";

export const TAB1_HEADING1 = "TAB1_HEADING1";
export const TAB1_HEADING2 = "TAB1_HEADING2";
export const TAB1_LI1 = "TAB1_LI1";
export const TAB1_LI2 = "TAB1_LI2";
export const TAB1_LI3 = "TAB1_LI3";
export const TAB1_LI4 = "TAB1_LI4";
export const TAB1_LI4_1 = "TAB1_LI4_1";
export const TAB1_LI4_2 = "TAB1_LI4_2";
export const TAB1_P1 = "TAB1_P1";

export const translations = {
  en: {
    [TAB1_HEADING1]: "Flybus - Luxury Travel",
    [TAB1_HEADING2]: "The silent features of Flybus are as follows:",
    [TAB1_LI1]:
      "Flybus - Volvo MultiAxle I-Shift Luxury Service from Kempegowda International Airport, Bengaluru.",
    [TAB1_LI2]: "Bus is fitted with tracking device and Fire Safety System.",
    [TAB1_LI3]: "Provide inbus restroom facility for long journey travels.",
    [TAB1_LI4_1]: "Please",
    [TAB1_LI4_2]:
      "for boarding point details at Kempegowda International Airport, Bengaluru.",
    [TAB1_P1]: "Online Seat Reservation",
  },
  kn: {
    [TAB1_HEADING1]: "ಫ್ಲೈಬಸ್ - ಐಷಾರಾಮಿ ಪ್ರಯಾಣ",
    [TAB1_HEADING2]: "ಫ್ಲೈಬಸ್‌ನ ವಿಶೇಷ ವೈಶಿಷ್ಟ್ಯಗಳು ಈ ಕೆಳಗಿನಂತಿವೆ:",
    [TAB1_LI1]:
      " ಫ್ಲೈಬಸ್ - ವೋಲ್ವೋ  ಮಲ್ಟಿ ಆಕ್ಸೆಲ್  ಐ -ಶಿಫ್ಟ್ ಬೆಂಗಳೂರಿನ ಕೆಂಪೇಗೌಡ ಅಂತರಾಷ್ಟ್ರೀಯ ವಿಮಾನ ನಿಲ್ದಾಣದಿಂದ  ಐಷಾರಾಮಿ ಸೇವೆ.",
    [TAB1_LI2]:
      "ಬಸ್‌ನಲ್ಲಿ ಟ್ರ್ಯಾಕಿಂಗ್ ಸಾಧನ ಮತ್ತು ಅಗ್ನಿ ಸುರಕ್ಷತಾ ವ್ಯವಸ್ಥೆಯನ್ನು ಅಳವಡಿಸಲಾಗಿದೆ.",
    [TAB1_LI3]: " ದೂರ ಪ್ರಯಾಣಕ್ಕಾಗಿ ಇನ್‌ಬಸ್ ರೆಸ್ಟ್ ರೂಂ ಸೌಲಭ್ಯವಿದೆ .",
    [TAB1_LI4_1]:
      "ಬೆಂಗಳೂರಿನ ಕೆಂಪೇಗೌಡ ಅಂತರಾಷ್ಟ್ರೀಯ ವಿಮಾನ ನಿಲ್ದಾಣದಲ್ಲಿ ಬೋರ್ಡಿಂಗ್ ಪಾಯಿಂಟ್ ವಿವರಗಳಿಗಾಗಿ ದಯವಿಟ್ಟು ",
    [TAB1_LI4_2]: ".",
    [TAB1_LI4]: "ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ.",
    [TAB1_P1]: "ಆನ್‌ಲೈನ್ ಸೀಟ್ ರಿಸರ್ವೇಶನ್ ಗಾಗಿ",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
